<div *ngIf="show" class="row mb-3 mb-sm-0">
  <div class="col col-md-8">

    <section i18n-title="Novinka" class="mt-3">
      <mat-expansion-panel expanded="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="h6" i18n>Novinka</div>
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

          <ng-container *ngIf="banner && safeHtmlContent">
            <div [innerHTML]="safeHtmlContent"></div>
            <div class="p-md-2" *ngIf="banner.popis">{{banner.popis}}</div>
          </ng-container>

          <hr/>

        <div class="d-flex justify-content-end">
          <div class="me-3">
            <b><a (click)="viacNezobrazovat()" i18n i18n-title title="Viac nezobrazovať">Viac nezobrazovať</a></b>
          </div>
        </div>

      </mat-expansion-panel>

    </section>

  </div>
</div>

